import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { getSupabaseClient } from '../lib/supabase';

export default function RootRedirect() {
  const navigate = useNavigate();
  const [isChecking, setIsChecking] = useState(true);

  useEffect(() => {
    async function checkAuthAndRedirect() {
      try {
        const supabase = getSupabaseClient();

        // Check if user is logged in
        const { data: { user }, error: authError } = await supabase.auth.getUser();

        if (authError || !user) {
          // Not logged in, redirect to login
          navigate('/login', { replace: true });
          return;
        }

        // User is logged in, check if terms are accepted
        const { data: profile } = await supabase
          .from('profiles')
          .select('terms_accepted')
          .eq('id', user.id)
          .single();

        if (profile && !profile.terms_accepted) {
          navigate('/terms', { replace: true });
          return;
        }

        // Check guide status
        const { data: guide } = await supabase
          .from('guides')
          .select('status')
          .eq('user_id', user.id)
          .single();

        // If guide is active, go to dashboard, otherwise go to onboarding
        if (guide && guide.status === 'active') {
          navigate('/dashboard', { replace: true });
        } else {
          navigate('/onboarding', { replace: true });
        }
      } catch (error) {
        console.error('Error checking auth status:', error);
        navigate('/login', { replace: true });
      } finally {
        setIsChecking(false);
      }
    }

    checkAuthAndRedirect();
  }, [navigate]);

  if (isChecking) {
    return (
      <div className="min-h-screen bg-[#FEF6D6] flex items-center justify-center">
        <p className="text-[#2C2731]">Loading...</p>
      </div>
    );
  }

  return null;
}
